import axios from 'axios';
import { BASE_URL } from '../utils/Constants';
import { getToken } from '../utils/session';

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;
